import { render, staticRenderFns } from "./ed-select-component-course.component.vue?vue&type=template&id=42941f61&scoped=true&"
import script from "./ed-select-component-course.component.ts?vue&type=script&lang=ts&"
export * from "./ed-select-component-course.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-select-component-course.component.scss?vue&type=style&index=0&id=42941f61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42941f61",
  null
  
)

export default component.exports